<template>
	<div v-if="_modals.length > 0" class="modal-view" @click="pop">
		<div class="modal" @click.stop="">
			<component :is="_modal.component" v-bind="_modal.props" v-on="_modal.events" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'modal-view',
		props: {
			fragments: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		computed: {
			_modals() {
				return this.$store.getters.modals;
			},
			_modal() {
				return this.$store.getters.modals[this.$store.getters.modals.length - 1];
			}
		},
		methods: {
			pop() {
				this.$store.commit('popModal');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.modal-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
		display: grid;
		justify-items: center;
		align-items: center;

		& > .modal {
			background-color: white;
		}
	}
</style>